import cn from './styles.module.sass';

interface IDeviceBadgeProps {
    device?: string;
}

export const DeviceBadge = ({ device }: IDeviceBadgeProps) => {
    return <div className={cn.deviceBadge}>{device}</div>;
};
